import cx from 'classnames';
import { useSwiper } from 'swiper/react';
import Button from '../../button';
import IconAdd from '../../icons/add';
import IconDelete from '../../icons/delete';
import IconZoomInFilled from '../../icons/zoom-in-filled';
import IconZoomOutFilled from '../../icons/zoom-out-filled';

export const SwiperButtonZoomIn = () => {
  const swiper = useSwiper();
  return (
    <Button
      isFullWidth={false}
      variant="NO-HOVER"
      disableHeight
      className="w-12 h-12 z-10 absolute top-2 lg:top-4 right-12 lg:right-16 p-2 lg:p-4 grid items-center justify-center bg-neutral-80 opacity-50 hover:opacity-100"
      onClick={() => {
        if (swiper.zoom.scale === 5) return;
        swiper.zoom.in(swiper.zoom.scale + 1);
      }}
    >
      <IconZoomInFilled
        className={cx('text-white w-4 h-4', {
          'text-neutral-50': swiper.zoom.scale === 5,
        })}
      ></IconZoomInFilled>
    </Button>
  );
};

export const SwiperButtonZoomOut = () => {
  const swiper = useSwiper();
  return (
    <Button
      isFullWidth={false}
      variant="NO-HOVER"
      disableHeight
      className="w-12 h-12 z-10 absolute top-2 lg:top-4 right-0 p-2 lg:p-4 grid items-center justify-center bg-neutral-80 opacity-50 hover:opacity-100"
      onClick={() => {
        if (swiper.zoom.scale === 1) return;
        swiper.zoom.in(swiper.zoom.scale - 1);
      }}
    >
      <IconZoomOutFilled
        className={cx('text-white z-10 w-4 h-4', {
          'text-neutral-50': swiper.zoom.scale === 1,
        })}
      ></IconZoomOutFilled>
    </Button>
  );
};
